import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/VehicleTitleTypes'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class VehicleTitleTypesStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "VehicleTitleTypesStore",
			variables: false,
		})
	}
}

export async function load_VehicleTitleTypes(params) {
  await initClient()

	const store = new VehicleTitleTypesStore()

	await store.fetch(params)

	return {
		VehicleTitleTypes: store,
	}
}
